export default {

  papeletas(state){
    return state.papeletas
  },

  papeleta_seleccionada(state){
    return state.papeleta_seleccionada
  },


  tipos_papeleta(state){
    return state.tipos_papeleta;
  },

  marcacion(state){
    return state.marcacion;
  },
}



// WEBPACK FOOTER //
// ./src/store/getters.js